import React from "react";
import "./Workers.css";
import Card from "./Card";

function index() {
  return (
    <div className="workers_container">
        <h1>Our Team</h1>
        <div className="workers">

      <Card
        src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
        name="Jenny Alex"
        job="Photographer"
        exp="2+ years"
        />
      <Card
        src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
        name="Jenny Alex"
        job="Photographer"
        exp="2+ years"
        />
      <Card
        src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
        name="Jenny Alex"
        job="Photographer"
        exp="2+ years"
        />
      <Card
        src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
        name="Jenny Alex"
        job="Photographer"
        exp="2+ years"
        />
        </div>
    </div>
  );
}

export default index;
